import { cn } from '@discover-lib/utils';

export type RootProps = React.ComponentPropsWithoutRef<'div'>;

export default function Root({ className, ...props }: RootProps) {
  return (
    <div className={cn('prose flex max-w-none flex-row items-start gap-2', className)} {...props} />
  );
}
